import React from 'react';
import endpoints from '../../define/endpoints';

const HeadlineListing = ({ listing, classes = '', before, after, onClick }) => {
  const imageUrl = `${listing.cover_image}`;
  const mosaic = listing.mosaic ? JSON.parse(listing.mosaic) : null;
  const dpr = window.devicePixelRatio;
  const offset = listing.offsetCustomer;

  const mosaicPositions = [
    'top-left',
    'bottom-left',
    'center',
    'top-right',
    'bottom-right',
  ]; //ordered by position in the gallery

  const positionCount = mosaic
    ? Object.keys(mosaic).reduce((acc, pos) => {
      const side = pos.includes('left')
        ? 'left'
        : pos.includes('right')
          ? 'right'
          : 'center';
      acc[side] = (acc[side] || 0) + 1;
      return acc;
    }, {})
    : {};

  const partnerPositions = mosaicPositions.filter(
    (pos) =>
      mosaic &&
      mosaic[pos] &&
      (!mosaic[pos].provider || mosaic[pos].provider === 'partner')
  );
  const customerPositions = mosaicPositions.filter(
    (pos) =>
      mosaic &&
      mosaic[pos] &&
      mosaic[pos].provider &&
      mosaic[pos].provider === 'customer'
  );

  const getDynamicIndex = (position, provider) => {
    if (provider === 'customer') {
      return customerPositions.indexOf(position) + offset;
    }
    return partnerPositions.indexOf(position);
  };

  return (
    <div className={`headline ${classes}`}>
      {mosaic && Object.keys(mosaic).length === 4 ? (
        <div className="headline__image headline__image-grid">
          <div className="headline__image-grid__container">
            {mosaicPositions.map((position, index) => {
              const item = mosaic[position];
              if (!item) return null;

              const side = position.includes('left')
                ? 'left'
                : position.includes('right')
                  ? 'right'
                  : 'center';
              const size =
                position === 'center'
                  ? `width=464&height=500&crop=464:500${!item.precrop ? ',smart' : ''}`
                  : positionCount[side] > 1
                    ? `width=360&height=246&crop=360:246${!item.precrop ? ',smart' : ''}`
                    : `width=360&height=500&crop=360:500${!item.precrop ? ',smart' : ''}`;

              const extendedClass =
                positionCount[side] === 1 && position !== 'center'
                  ? 'headline__image-grid__img--extended'
                  : '';

              const dynamicIndex = getDynamicIndex(
                position,
                item.provider || 'partner'
              );

              return item.is_video ? (
                <video
                  key={position}
                  controls
                  controlsList="nodownload"
                  src={`${endpoints.bucket}${item.url}`}
                  autoPlay
                  muted
                  playsInline
                  loop
                  className={`headline__image-grid__img headline__image-grid__img--${position} ${extendedClass} ${!listing.available ? 'headline__image--unavailable' : ''
                    }`}
                  onClick={(e) => {
                    e.preventDefault();
                    onClick && onClick(dynamicIndex);
                  }}
                />
              ) : (
                <img
                  key={position}
                  className={`headline__image-grid__img headline__image-grid__img--${position} ${extendedClass} ${!listing.available ? 'headline__image--unavailable' : ''
                    }`}
                  onClick={() => onClick && onClick(dynamicIndex)}
                  src={`${endpoints.bucket}${item.url}?${size}${dpr > 1 ? `&dpr=${dpr}` : ''
                    }${item.precrop ? `&precrop=${item.precrop}` : ''}`}
                  alt={listing.title}
                  fetchpriority="high"
                />
              );
            })}
          </div>
        </div>
      ) : (
        listing.cover_image && (
          <figure
            className={`headline__image ${!listing.available ? 'headline__image--unavailable' : ''
              }`}
            onClick={onClick}
          >
            <picture>
              <source
                media="(max-width: 640px)"
                srcSet={`${imageUrl}?width=640${dpr > 1 ? `&dpr=${dpr}` : ''}${listing.cover_image_precrop ? `&precrop=${listing.cover_image_precrop}` : ''}`}
              />
              <source
                media="(max-width: 768px)"
                srcSet={`${imageUrl}?width=768${dpr > 1 ? `&dpr=${dpr}` : ''}${listing.cover_image_precrop ? `&precrop=${listing.cover_image_precrop}` : ''}`}
              />
              <source
                media="(max-width: 1024px)"
                srcSet={`${imageUrl}?width=1024${dpr > 1 ? `&dpr=${dpr}` : ''}${listing.cover_image_precrop ? `&precrop=${listing.cover_image_precrop}` : ''}`}
              />
              <img
                src={`${imageUrl}?width=1200&height=500&crop=1200:500${!listing.cover_image_precrop ? ',smart' : ''}${dpr > 1 ? `&dpr=${dpr}` : ''
                  }${listing.cover_image_precrop ? `&precrop=${listing.cover_image_precrop}` : ''}`}
                alt={listing.title}
                fetchpriority="high"
              />
            </picture>
          </figure>
        )
      )}

      {before && (
        <div className="headline__before">
          <div className="grid-container">
            <div className="grid-x grid-padding-x">
              <div className="cell before-container">{before}</div>
            </div>
          </div>
        </div>
      )}

      {after && (
        <div className="headline__after">
          <div className="grid-container">
            <div className="grid-x grid-padding-x">
              <div className="cell">{after}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeadlineListing;
